import { useEffect, useRef, useState } from 'react';
import { ChatCircleText, X } from '@phosphor-icons/react';
import RequestData from '../pages/RequestData';
export default function RequestDataModal({onClose}) {
 const dialog=useRef(null);
 const [busy,setBusy]=useState(false);
 useEffect(()=>{
  const element=dialog.current, previous=document.body.style.overflow;
  element.showModal(); document.body.style.overflow='hidden';
  return ()=>{element.close();document.body.style.overflow=previous;};
 },[]);
 return <dialog ref={dialog} className="sdx-request-dialog" aria-labelledby="request-data-title" aria-describedby="request-data-intro"
  onCancel={event=>{event.preventDefault();if(!busy)onClose();}}
  onClick={event=>{
   if(event.target!==event.currentTarget || busy)return;
   const rect=event.currentTarget.getBoundingClientRect();
   if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)onClose();
  }}>
  <div className="sdx-request-dialog-bar"><span><ChatCircleText size={19}/> A request to the SustainDex team</span><button type="button" autoFocus disabled={busy} onClick={onClose} aria-label="Close data request"><X size={20}/></button></div>
  <RequestData embedded onBusyChange={setBusy}/>
 </dialog>;
}
